// extracted by mini-css-extract-plugin
module.exports = {"dailyEventWrapper":"Event_dailyEventWrapper__3QqRC","dailyEventTitle":"Event_dailyEventTitle___ORK7"};